class DataPricingClass {
    async setPrice(rowsToBePriced, pricingOptions) {
        // Fix pricing options if they are not set properly.
        const markup = pricingOptions.difference ? pricingOptions.difference : 0;
        const priceFrom = pricingOptions.priceFrom ? pricingOptions.priceFrom : -1;
        const priceTo = pricingOptions.priceTo ? pricingOptions.priceTo : Infinity;

        const roundingFunction = { aufrunden: Math.ceil, abrunden: Math.floor }[
            pricingOptions.roundingType
        ];
        const roundingChoiceFunction = { aufrunden: Math.min, abrunden: Math.max }[
            pricingOptions.roundingType
        ];

        return rowsToBePriced.map(article => {
            const referencePrice = article[pricingOptions.referenceValue];
            if (referencePrice && referencePrice >= priceFrom && referencePrice <= priceTo) {
                const unroundedPrice = referencePrice * (markup / 100 + 1);
                if (unroundedPrice > 0) {
                    // We calculate all candidates for the rounded price and choose the one closest to the target price, depending on the selected rounding behavior.
                    if (pricingOptions.roundingOptions.length > 0) {
                        article.priceNew = roundingChoiceFunction(
                            ...pricingOptions.roundingOptions.map(roundingOption => {
                                return (
                                    roundingFunction(unroundedPrice - roundingOption + 1) +
                                    roundingOption -
                                    1
                                );
                            })
                        );
                    } else {
                        article.priceNew = unroundedPrice;
                    }
                    return article;
                } else {
                    // If we were unable to determine a plausible price, we set it to null.
                    article.priceNew = null;
                }
            }
            return article;
        });
    }
}

export default new DataPricingClass();
